<template>
  <form ref="form" class="subscription_prefs_form" method="post" action="https://australia-southeast1-foxtware.cloudfunctions.net/apexShopifyCustomerInfoUpdate" @submit.prevent="update">
    <h2>Get the Goss</h2>
    
    <div class="consent_controls">
      <div class="consent_control">
        <span class="consent_control_icon" v-html="theme.icons.mail('auto', 'auto')"></span>
        <input name="accepts_email" type="hidden" value="false">
        <input name="accepts_email" id="accepts_email" type="checkbox" value="true" :checked="acceptsEmailState" @change="touch">
        <label for="accepts_email">Email</label>
      </div>

      <div class="consent_control" v-if="sms_consentable === 'true'">
        <span class="consent_control_icon _loppy" v-html="theme.icons.mobile_message('auto', 'auto')"></span>
        <input name="accepts_sms" type="hidden" value="false">
        <input name="accepts_sms" id="accepts_sms" type="checkbox" value="true" :checked="acceptsSmsState" @change="touch">
        <label for="accepts_sms">Mobile</label>
      </div>
    </div>

    <button type="submit" class="btn btn-primary" v-html="buttonHtml" :disabled="!touched">Update</button>
  </form>
</template>

<script>
  export default {
    name: 'subscription_prefs_form',
    props: ['accepts_email', 'accepts_sms', 'sms_consentable', 'token', 'value', 'region'],
    data() {
      return {
        acceptsEmailState: this.accepts_email === 'true',
        acceptsSmsState: this.accepts_sms === 'true',
        busy: false,
        buttonHtml: 'Update',
        touched: false,
      }
    },
    methods: {
      log: function(e) {
        console.log(this);
        console.log(this.accepts_email);
        console.log(this.accepts_sms);
      },
      touch: function() {
        this.touched = true;
      },
      update: async function(e) {

        if (this.busy) {
          console.warn('Take a deep breath');
          return;
        }

        const { form } = this.$refs;

        const formData = new FormData(form);
        const formDataObj = Object.fromEntries([...formData]);
        console.log(formDataObj);

        const { accepts_email, accepts_sms } = formDataObj;

        const willUpdateEmail = accepts_email !== this.acceptsEmailState.toString();
        const willUpdateSms = accepts_sms !== this.acceptsSmsState.toString();
        const willUpdate = willUpdateEmail || willUpdateSms;
        const willUpdateAll = willUpdateEmail && willUpdateSms;

        if (!willUpdate) {
          return;
        }

        this.busy = true;
        this.buttonHtml = '...';

        const stringyBooleanToPayload = stringyBoolean => {
          return stringyBoolean === 'true' ? {
            marketingState: 'SUBSCRIBED',
            marketingOptInLevel: 'SINGLE_OPT_IN',
          } : {
            marketingState: 'UNSUBSCRIBED',
          }
        };

        let emailUpdated;
        let smsUpdated;
        let minTime;

        [
          minTime, 
          emailUpdated,
          smsUpdated,
        ] = await Promise.all([
          this.wait(2000),
          willUpdateEmail ? this.makeRequest('email_consent', stringyBooleanToPayload(accepts_email)) : null,
          willUpdateSms ? this.makeRequest('sms_consent', stringyBooleanToPayload(accepts_sms)) : null,
        ]);

        console.log(minTime, emailUpdated, smsUpdated);

        if (emailUpdated) {
          // alert('emailUpdated');
          this.acceptsEmailState = accepts_email === 'true';
        }
        if (smsUpdated) {
          // alert('smsUpdated');
          this.acceptsSmsState = accepts_sms === 'true';
        }

        if (emailUpdated === false || smsUpdated === false) {
          alert(`Sorry babe, something went wrong, try again in a few.`);
          this.acceptsEmailState = this.acceptsEmailState;
          this.acceptsSmsState = this.acceptsSmsState;
          this.buttonHtml = 'Error';
        } else {
          this.buttonHtml = 'Done!';
        }

        await this.wait(1000);

        this.busy = false;
        this.buttonHtml = 'Update';
      },
      makeRequest: async function(target, payload) {
        const { form } = this.$refs;
        const { method, action } = form;

        let response;
        try {
          response = await fetch(action, {
            method,
            headers: {
              'Content-Type': 'application/json',
              'x-wf-token': this.token,
              'x-wf-value': this.value,
            },
            body: JSON.stringify({
              config: this.region,
              customerId: this.value,
              target,
              payload,
            }),
          });

          if (!response?.ok) {
            return false;
          }

          if (response?.error) {
            return false;
          }

          return true;
        } catch(err) {
          alert(`Soz babe, network error, please check your connection and try again.`);
          console.error('Network error', err);
          return false;
        }
      },
      wait: ms => new Promise((resolve, reject) => setTimeout(resolve, ms)),
    },
  }
</script>